export default {
  path: 'checklists',
  name: 'checklist',
};
